let substituteList = [
  {
    attributes: {
      available_in_inventory_days: 1,
      case_description: '15X2X227GR',
      case_type: 'CAISSE',
      dimension_unit: 'CM',
      items_per_pallet: 32,
      items_per_row: 8,
      pricing_source: 'RG',
      weight_unit: 'KG',
    },
    benefits: 'N/A',
    brand: 'MOTHER PARKERS',
    case_quantity: 30,
    category: 'COFFEE GRAIN',
    category_l1: 'Beverages',
    category_l2: 'Coffees',
    category_l3: 'Regular Coffee',
    category_l4: 'Filter Pack Coffee',
    cost: 0,
    cube: 41115.436056,
    default_vendor_code: 'COL',
    description: 'GROUND COFFEE, FILTER PACKAGE 15-2-8OZ',
    dimension_unit: 'CM',
    flags: ['featured', 'click_collect'],
    gallery: [
      {
        id: '342655',
        original:
          'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_P_1000x1000.jpg',
        thumbnail:
          'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_P_240x240.jpg',
      },
      {
        id: '342657',
        original:
          'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_X1_1000x1000.jpg',
        thumbnail:
          'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_X1_240x240.jpg',
      },
      {
        id: '342659',
        original:
          'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_X_1000x1000.jpg',
        thumbnail:
          'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_X_240x240.jpg',
      },
      {
        id: '342653',
        original:
          'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_C_1000x1000.jpg',
        thumbnail:
          'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_C_240x240.jpg',
      },
    ],
    'gallery.id': ['342655', '342657', '342659', '342653'],
    'gallery.original': [
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_P_1000x1000.jpg',
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_X1_1000x1000.jpg',
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_X_1000x1000.jpg',
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_C_1000x1000.jpg',
    ],
    'gallery.thumbnail': [
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_P_240x240.jpg',
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_X1_240x240.jpg',
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_X_240x240.jpg',
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_C_240x240.jpg',
    ],
    gtin: '00060731000816',
    haz_mat: '',
    height: 27.18,
    id: '276489',
    image: {
      id: 342655,
      original:
        'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_P_1000x1000.jpg',
      thumbnail:
        'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_P_240x240.jpg',
    },
    'image.id': 342655,
    'image.original':
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_P_1000x1000.jpg',
    'image.thumbnail':
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_P_240x240.jpg',
    is_active: true,
    lang: 'en-CA',
    length: 50.04,
    manufacturer: 'MOTHER PARKERS TEA/COFFEE INC',
    mpn: '1103423',
    name: 'COFFEE COLD BREW WITH FILTER',
    pack: 30,
    price: 236.95,
    product_id: 'CO119271',
    product_life: 240,
    ship_weight: 7.711,
    sku: '276489',
    slug: 'cafe-infuse-a-froid-a-filtre-276489.html',
    source: 'colabor',
    status: 'In Stock',
    taxable: false,
    temperature: 'D',
    temperature_description: 'Dry',
    upc: '00060731000816',
    ups_ship_height: 10.7,
    ups_ship_length: 19.7,
    ups_ship_weight: 17,
    ups_ship_width: 11.9,
    vendors: [
      {
        code: 'COL',
        name: 'Colabor',
      },
    ],
    warehoused: true,
    weight: 6.803,
    weight_unit: 'KG',
    width: 30.23,
  },
  {
    attributes: {
      available_in_inventory_days: 1,
      case_description: '15X2X227GR',
      case_type: 'CAISSE',
      dimension_unit: 'CM',
      items_per_pallet: 32,
      items_per_row: 8,
      pricing_source: 'RG',
      weight_unit: 'KG',
    },
    benefits: 'N/A',
    brand: 'MOTHER PARKERS',
    case_quantity: 30,
    category: 'COFFEE GRAIN',
    category_l1: 'Beverages',
    category_l2: 'Coffees',
    category_l3: 'Regular Coffee',
    category_l4: 'Filter Pack Coffee',
    cost: 0,
    cube: 41115.436056,
    default_vendor_code: 'COL',
    description: 'GROUND COFFEE, FILTER PACKAGE 15-2-8OZ',
    dimension_unit: 'CM',
    flags: ['featured', 'click_collect'],
    gallery: [
      {
        id: '342655',
        original:
          'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_P_1000x1000.jpg',
        thumbnail:
          'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_P_240x240.jpg',
      },
      {
        id: '342657',
        original:
          'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_X1_1000x1000.jpg',
        thumbnail:
          'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_X1_240x240.jpg',
      },
      {
        id: '342659',
        original:
          'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_X_1000x1000.jpg',
        thumbnail:
          'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_X_240x240.jpg',
      },
      {
        id: '342653',
        original:
          'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_C_1000x1000.jpg',
        thumbnail:
          'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_C_240x240.jpg',
      },
    ],
    'gallery.id': ['342655', '342657', '342659', '342653'],
    'gallery.original': [
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_P_1000x1000.jpg',
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_X1_1000x1000.jpg',
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_X_1000x1000.jpg',
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_C_1000x1000.jpg',
    ],
    'gallery.thumbnail': [
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_P_240x240.jpg',
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_X1_240x240.jpg',
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_X_240x240.jpg',
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_C_240x240.jpg',
    ],
    gtin: '00060731000816',
    haz_mat: '',
    height: 27.18,
    id: '276489',
    image: {
      id: 342655,
      original:
        'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_P_1000x1000.jpg',
      thumbnail:
        'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_P_240x240.jpg',
    },
    'image.id': 342655,
    'image.original':
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_P_1000x1000.jpg',
    'image.thumbnail':
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/00060731000816_GS1_FS_P_240x240.jpg',
    is_active: true,
    lang: 'en-CA',
    length: 50.04,
    manufacturer: 'MOTHER PARKERS TEA/COFFEE INC',
    mpn: '1103423',
    name: 'COFFEE COLD BREW WITH FILTER',
    pack: 30,
    price: 236.95,
    product_id: 'CO119271',
    product_life: 240,
    ship_weight: 7.711,
    sku: '276489',
    slug: 'cafe-infuse-a-froid-a-filtre-276489.html',
    source: 'colabor',
    status: 'In Stock',
    taxable: false,
    temperature: 'D',
    temperature_description: 'Dry',
    upc: '00060731000816',
    ups_ship_height: 10.7,
    ups_ship_length: 19.7,
    ups_ship_weight: 17,
    ups_ship_width: 11.9,
    vendors: [
      {
        code: 'COL',
        name: 'Colabor',
      },
    ],
    warehoused: true,
    weight: 6.803,
    weight_unit: 'KG',
    width: 30.23,
  },
]

const compareWithOtherProducts = [
  {
    attributes: {
      available_in_inventory_days: 1,
      case_description: '2X2LT',
      case_type: 'CAISSE',
      dimension_unit: 'CM',
      items_per_pallet: 84,
      items_per_row: 42,
      pricing_source: 'PR',
      weight_unit: 'KG',
    },
    'sold-by': 'FoodServiceDirect',
    ratings: 3,
    benefits: 'Stability and long shelf life',
    brand: 'PIED-MONT',
    case_quantity: 2,
    category: 'PUREE COULIS',
    category_l1: 'Foods',
    category_l2: 'Sauces',
    category_l3: 'Wet Sauces',
    category_l4: 'Specialty Sauces',
    cost: 0,
    cube: 7931.159334,
    default_vendor_code: 'COL',
    description: 'Ready to serve',
    dimension_unit: 'CM',
    flags: ['click_collect'],
    gallery: [
      {
        id: '306225',
        original:
          'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/70064819328624_GS1_FS_P_1000x1000.jpg',
        thumbnail:
          'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/70064819328624_GS1_FS_P_240x240.jpg',
      },
      {
        id: '306223',
        original:
          'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/70064819328624_GS1_FS_C_1000x1000.jpg',
        thumbnail:
          'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/70064819328624_GS1_FS_C_240x240.jpg',
      },
    ],
    'gallery.id': ['306225', '306223'],
    'gallery.original': [
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/70064819328624_GS1_FS_P_1000x1000.jpg',
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/70064819328624_GS1_FS_C_1000x1000.jpg',
    ],
    'gallery.thumbnail': [
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/70064819328624_GS1_FS_P_240x240.jpg',
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/70064819328624_GS1_FS_C_240x240.jpg',
    ],
    gtin: '70064819328624',
    haz_mat: '',
    height: 27.18,
    id: '280329',
    image: {
      id: 306225,
      original:
        'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/70064819328624_GS1_FS_P_1000x1000.jpg',
      thumbnail:
        'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/70064819328624_GS1_FS_P_240x240.jpg',
    },
    'image.id': 306225,
    'image.original':
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/70064819328624_GS1_FS_P_1000x1000.jpg',
    'image.thumbnail':
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/70064819328624_GS1_FS_P_240x240.jpg',
    is_active: true,
    lang: 'en-CA',
    length: 19.81,
    manufacturer: 'PIED-MONT/DORA',
    mpn: '32862',
    name: 'COULIS RASPBERRY',
    pack: 2,
    price: 46.95,
    product_id: 'CO29072',
    product_life: 548,
    ship_weight: 5.058,
    sku: '280329',
    slug: 'coulis-framboise-280329.html',
    source: 'colabor',
    status: 'In Stock',
    taxable: false,
    temperature: 'D',
    temperature_description: 'Dry products',
    upc: '70064819328624',
    ups_ship_height: '10.7',
    ups_ship_length: '7.8',
    ups_ship_weight: '11.15',
    ups_ship_width: '5.8',
    vendors: [
      {
        code: 'COL',
        name: 'Colabor',
      },
    ],
    warehoused: true,
    weight: 5.22,
    weight_unit: 'KG',
    width: 14.73,
  },
  {
    attributes: {
      available_in_inventory_days: 1,
      case_description: '12X420ML',
      case_type: 'CAISSE',
      dimension_unit: 'CM',
      items_per_pallet: 54,
      items_per_row: 18,
      pricing_source: 'RG',
      weight_unit: 'KG',
    },
    'sold-by': 'FoodServiceDirect',
    ratings: 3,
    benefits:
      'With our unique decorating tip and product formulation, product flows easily to ensure that even the most inexperiencd staff member can easily create memorable plate designs.',
    brand: "SMUCKER'S",
    case_quantity: 12,
    category: 'PUREE COULIS',
    category_l1: 'Foods',
    category_l2: 'Sauces',
    category_l3: 'Wet Sauces',
    category_l4: 'Specialty Sauces',
    cost: 0,
    cube: 14351.696,
    default_vendor_code: 'COL',
    description: 'SMUCKER 420 ML PLATESCAPERS CARAMEL CANADIAN',
    dimension_unit: 'CM',
    flags: ['click_collect'],
    gallery: [
      {
        id: '323213',
        original:
          'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060558_GS1_FS_P_1000x1000.jpg',
        thumbnail:
          'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060558_GS1_FS_P_240x240.jpg',
      },
      {
        id: '323211',
        original:
          'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060558_GS1_FS_C_1000x1000.jpg',
        thumbnail:
          'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060558_GS1_FS_C_240x240.jpg',
      },
    ],
    'gallery.id': ['323213', '323211'],
    'gallery.original': [
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060558_GS1_FS_P_1000x1000.jpg',
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060558_GS1_FS_C_1000x1000.jpg',
    ],
    'gallery.thumbnail': [
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060558_GS1_FS_P_240x240.jpg',
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060558_GS1_FS_C_240x240.jpg',
    ],
    gtin: '10051500060558',
    haz_mat: '',
    height: 21.4,
    id: '279882',
    image: {
      id: 323213,
      original:
        'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060558_GS1_FS_P_1000x1000.jpg',
      thumbnail:
        'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060558_GS1_FS_P_240x240.jpg',
    },
    'image.id': 323213,
    'image.original':
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060558_GS1_FS_P_1000x1000.jpg',
    'image.thumbnail':
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060558_GS1_FS_P_240x240.jpg',
    is_active: true,
    lang: 'en-CA',
    length: 33.2,
    manufacturer: 'SMUCKER CANADA',
    mpn: '06055',
    name: 'COULIS CARAMEL',
    pack: 12,
    price: 57.95,
    product_id: 'CO2461',
    product_life: 365,
    ship_weight: 7.4,
    sku: '279882',
    slug: 'coulis-caramel-279882.html',
    source: 'colabor',
    status: 'In Stock',
    taxable: false,
    temperature: 'D',
    temperature_description: 'Dry products',
    upc: '10051500060558',
    ups_ship_height: '8.43',
    ups_ship_length: '13.07',
    ups_ship_weight: '16.31',
    ups_ship_width: '7.95',
    vendors: [
      {
        code: 'COL',
        name: 'Colabor',
      },
    ],
    warehoused: true,
    weight: 7.4,
    weight_unit: 'KG',
    width: 20.2,
  },
  {
    attributes: {
      available_in_inventory_days: 1,
      case_description: '12X420ML',
      case_type: 'CAISSE',
      dimension_unit: 'CM',
      items_per_pallet: 36,
      items_per_row: 18,
      pricing_source: 'RG',
      weight_unit: 'KG',
    },
    'sold-by': 'FoodServiceDirect',
    ratings: 3,
    benefits:
      'With our unique decorating tip and product formulation, product flows easily to ensure that even the most inexperiencd staff member can easily create memorable plate designs.',
    brand: "SMUCKER'S",
    case_quantity: 12,
    category: 'PUREE COULIS',
    category_l1: 'Foods',
    category_l2: 'Sauces',
    category_l3: 'Wet Sauces',
    category_l4: 'Specialty Sauces',
    cost: 0,
    cube: 14028,
    default_vendor_code: 'COL',
    description: 'SMUCKER 420 ML PLATESCAPERS RASPBERRY CANADIAN',
    dimension_unit: 'CM',
    flags: ['click_collect'],
    gallery: [
      {
        id: '319239',
        original:
          'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060572_1_1000x1000.jpg',
        thumbnail:
          'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060572_1_240x240.jpg',
      },
      {
        id: '319237',
        original:
          'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060572_GS1_FS_P_1000x1000.jpg',
        thumbnail:
          'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060572_GS1_FS_P_240x240.jpg',
      },
      {
        id: '319235',
        original:
          'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060572_GS1_FS_C_1000x1000.jpg',
        thumbnail:
          'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060572_GS1_FS_C_240x240.jpg',
      },
    ],
    'gallery.id': ['319239', '319237', '319235'],
    'gallery.original': [
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060572_1_1000x1000.jpg',
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060572_GS1_FS_P_1000x1000.jpg',
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060572_GS1_FS_C_1000x1000.jpg',
    ],
    'gallery.thumbnail': [
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060572_1_240x240.jpg',
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060572_GS1_FS_P_240x240.jpg',
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060572_GS1_FS_C_240x240.jpg',
    ],
    gtin: '10051500060572',
    haz_mat: '',
    height: 21,
    id: '279876',
    image: {
      id: 319239,
      original:
        'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060572_1_1000x1000.jpg',
      thumbnail:
        'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060572_1_240x240.jpg',
    },
    'image.id': 319239,
    'image.original':
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060572_1_1000x1000.jpg',
    'image.thumbnail':
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060572_1_240x240.jpg',
    is_active: true,
    lang: 'en-CA',
    length: 33.4,
    manufacturer: 'SMUCKER CANADA',
    mpn: '06057',
    name: 'COULIS RASPBERRY',
    pack: 12,
    price: 84.95,
    product_id: 'CO2460',
    product_life: 365,
    ship_weight: 7.5,
    sku: '279876',
    slug: 'coulis-framboise-279876.html',
    source: 'colabor',
    status: 'In Stock',
    taxable: false,
    temperature: 'D',
    temperature_description: 'Dry products',
    upc: '10051500060572',
    ups_ship_height: '8.27',
    ups_ship_length: '13.15',
    ups_ship_weight: '16.53',
    ups_ship_width: '7.87',
    vendors: [
      {
        code: 'COL',
        name: 'Colabor',
      },
    ],
    warehoused: true,
    weight: 7.5,
    weight_unit: 'KG',
    width: 20,
  },
  {
    attributes: {
      available_in_inventory_days: 1,
      case_description: '12X420ML',
      case_type: 'CAISSE',
      dimension_unit: 'CM',
      items_per_pallet: 54,
      items_per_row: 18,
      pricing_source: 'RG',
      weight_unit: 'KG',
    },
    'sold-by': 'FoodServiceDirect',
    ratings: 3,
    benefits:
      'With our unique decorating tip and product formulation, product flows easily to ensure that even the most inexperiencd staff member can easily create memorable plate designs.',
    brand: "SMUCKER'S",
    case_quantity: 12,
    category: 'PUREE COULIS',
    category_l1: 'Foods',
    category_l2: 'Sauces',
    category_l3: 'Wet Sauces',
    category_l4: 'Specialty Sauces',
    cost: 0,
    cube: 14198.976000000002,
    default_vendor_code: 'COL',
    description: 'SMUCKERS 420 ML PLATESCAPERS CHOCOLATE CANADIAN',
    dimension_unit: 'CM',
    flags: [],
    gallery: [
      {
        id: '319233',
        original:
          'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060541_GS1_FS_P_1000x1000.jpg',
        thumbnail:
          'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060541_GS1_FS_P_240x240.jpg',
      },
      {
        id: '319231',
        original:
          'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060541_GS1_FS_C_1000x1000.jpg',
        thumbnail:
          'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060541_GS1_FS_C_240x240.jpg',
      },
    ],
    'gallery.id': ['319233', '319231'],
    'gallery.original': [
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060541_GS1_FS_P_1000x1000.jpg',
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060541_GS1_FS_C_1000x1000.jpg',
    ],
    'gallery.thumbnail': [
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060541_GS1_FS_P_240x240.jpg',
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060541_GS1_FS_C_240x240.jpg',
    ],
    gtin: '10051500060541',
    haz_mat: '',
    height: 21.6,
    id: '279872',
    image: {
      id: 319233,
      original:
        'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060541_GS1_FS_P_1000x1000.jpg',
      thumbnail:
        'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060541_GS1_FS_P_240x240.jpg',
    },
    'image.id': 319233,
    'image.original':
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060541_GS1_FS_P_1000x1000.jpg',
    'image.thumbnail':
      'https://fsd-canada.s3.amazonaws.com/prod_imgs_col/10051500060541_GS1_FS_P_240x240.jpg',
    is_active: true,
    lang: 'en-CA',
    length: 33.2,
    manufacturer: 'SMUCKER CANADA',
    mpn: '06054',
    name: 'COULIS CHOCOLATE',
    pack: 12,
    price: 64.95,
    product_id: 'CO2455',
    product_life: 365,
    ship_weight: 7.6,
    sku: '279872',
    slug: 'coulis-chocolat-279872.html',
    source: 'colabor',
    status: 'In Stock',
    taxable: false,
    temperature: 'D',
    temperature_description: 'Dry',
    upc: '10051500060541',
    ups_ship_height: 8.5,
    ups_ship_length: 13.07,
    ups_ship_weight: 16.76,
    ups_ship_width: 7.8,
    vendors: [
      {
        code: 'COL',
        name: 'Colabor',
      },
    ],
    warehoused: true,
    weight: 7.6,
    weight_unit: 'KG',
    width: 19.8,
  },
  {
    attributes: {
      available_in_inventory_days: 1,
      case_description: '6X2.84LT',
      case_type: 'CAISSE',
      dimension_unit: 'CM',
      items_per_pallet: 56,
      items_per_row: 8,
      pricing_source: 'RG',
      weight_unit: 'KG',
    },
    'sold-by': 'FoodServiceDirect',
    ratings: 3,
    benefits:
      'Excellent source of vitamin A, Without cholesterol, No saturated fat, Few calories, Low fat content, Sodium free, Source of fibers and Without trans fatty acids',
    brand: 'ARCTIC GARDENS',
    case_quantity: 6,
    category: 'PUREE COULIS',
    category_l1: 'Foods',
    category_l2: 'Vegetables',
    category_l3: 'Canned and Packed Vegetables',
    category_l4: 'Canned Pumpkins',
    cost: 0,
    cube: 26305.664,
    default_vendor_code: 'COL',
    description:
      'Canned vegetables are ready to serve, nutritive and shelf stable, making operations and storage easy.  This Pumpkin Puree is an excellent Source of Fibre.',
    dimension_unit: 'CM',
    flags: ['click_collect'],
    gtin: '10055686277762',
    haz_mat: '',
    height: 17.6,
    id: '278280',
    image: {},
    'image.id': 132953,
    'image.original':
      'https://colaborweb.blob.core.windows.net/images/10055686274464_GS1_FS_P_EN_1000x1000.jpg',
    'image.thumbnail':
      'https://colaborweb.blob.core.windows.net/images/10055686274464_GS1_FS_P_EN_240x240.jpg',
    is_active: true,
    is_in_stock: true,
    lang: 'en-CA',
    length: 47.6,
    manufacturer: 'ALIMENTS NORTERA INC',
    mpn: '277762',
    name: 'MASH PUMPKIN',
    pack: 6,
    price: 92.95,
    product_id: 'CO132956',
    product_life: 1080,
    ship_weight: 21.44,
    ships_in_days: 1,
    sku: '278280',
    slug: 'puree-citrouille-278280.html',
    source: 'colabor',
    status: 'In Stock',
    taxable: false,
    temperature: 'D',
    temperature_description: 'Dry products',
    upc: '10055686277762',
    ups_ship_height: '6.93',
    ups_ship_length: '18.74',
    ups_ship_weight: '47.27',
    ups_ship_width: '12.36',
    vendors: [
      {
        code: 'COL',
        name: 'Colabor',
      },
    ],
    warehoused: true,
    weight: 20.45,
    weight_unit: 'KG',
    width: 31.4,
  },
]

const productData = {
  substituteList,
  compareWithOtherProducts,
}
export default productData
